define('GameDayCore/GDModel/load/manager/GumboHeartbeat',['require','exports','module','../../../GDControl/GameModelLocator/GameModelLocator','../../storage/ModelCache','../../storage/ResponseCache','data-fetcher/data-fetcher','message-service/message-service','../../enums/datasources/Datasources','../../enums/datasources/DatasourceToEventMap','../../enums/events/EventTypes','../../enums/baseball/GameStates','../../../GDUtil/resources/GDConfig','extant/extant','../../../GDUtil/window/Logg','../execute/FileRequestItem','gameday-index-enums/enums/baseball/GIDDecoder','../../../GDUtil/dataMapping/GameStateUtil'],function(require, exports, module) {
    var GameModelLocator = require("../../../GDControl/GameModelLocator/GameModelLocator"),
        ModelCache = require("../../storage/ModelCache"),
        ResponseCache = require("../../storage/ResponseCache"),
        dataFetcher = require("data-fetcher/data-fetcher"),
        MessageService = require("message-service/message-service"),
        Datasources = require("../../enums/datasources/Datasources"),
        DatasourceToEventMap = require("../../enums/datasources/DatasourceToEventMap"),
        EventTypes = require("../../enums/events/EventTypes"),
        GameStates = require("../../enums/baseball/GameStates"),
        GDConfig = require("../../../GDUtil/resources/GDConfig"),
        exists = require("extant/extant"),
        logg = require("../../../GDUtil/window/Logg"),
        FileRequestItem = require("../execute/FileRequestItem"),
        GameId = require("gameday-index-enums/enums/baseball/GIDDecoder"),
        GameStateUtil = require("../../../GDUtil/dataMapping/GameStateUtil");

    function GumboHeartbeat(gid, gameItem) {
        var gameID = gid,
            gameItem = gameItem
            params = gameItem.addGameParams(),
            intervalId = -1,
            lastCall = new Date(0).getTime(),
            firstRun = true,
            active = false,
            paused = false,
            initComplete = false;

        this.init = function() {
            dataFetcher.get(new FileRequestItem(Datasources.STATIC_RESOURCES, true, params, handleResourcesLoad));
            //this.start();
        };

        function handleResourcesLoad(result) {
            if (!exists(result.data)) {
                logg.log("The static resources failed to load, sorry.");
                return;
            }

            GDConfig.staticResources = result.data;

            active = true;
            paused = false;
            startHeartbeat();
        }

        this.start = function() {
            if (active && !paused) { return; }

            active = true;
            paused = false;
            startHeartbeat();
        };

        this.pause = function() {
            if (active && paused) { return; }
            active = true;
            paused = true;

            stopHeartbeat();
        };

        this.stop = function() {
            if (!active && !paused) { return; }
            active = false;
            paused = false;

            stopHeartbeat();
        };

        this.active = function() { return active; }

        function startHeartbeat() {
            checkHeartbeat();

            if (intervalId == -1) {
                intervalId = setInterval(checkHeartbeat, 1000);
            }
        }

        function stopHeartbeat() {
            clearInterval(intervalId);
            intervalId = -1;
        }

        function checkHeartbeat() {
            var lastCallMade = (new Date().getTime() - lastCall);
            if (lastCallMade > GDConfig.wait * 1000) {
                executeHeartBeat();
            }

        }

        function executeHeartBeat() {
            lastCall = new Date().getTime();
            logg.log("GET SOME GUMBO!");
            dataFetcher.get(new FileRequestItem(Datasources.GUMBO, true, params, handleGumboLoad));
        }

        function handleGumboLoad(result) {
            if (!exists(result.data)) {
                logg.log("There was a fatal error loading the game data");
                return;
            }

            ModelCache.storeGumboData(gameID, result.data);

            if (firstRun) {
                firstRun = false;
                initComplete = true;
                MessageService.publish(EventTypes.INIT_DATA_LOADED);
            }

            checkState();

            MessageService.publish(DatasourceToEventMap.gumbo);
            MessageService.publish(EventTypes.UPDATE);

            if (exists(result, "data.metaData.wait")) { GDConfig.wait = result.data.metaData.wait; }
        }

        function checkState() {
            var game = GameModelLocator.getGameData();
            if (!exists(game)) { return; }
            // this is misspelled in the data, needs to corrected
            else if (game.gameData.status.detailedState === "Final") {
                stopHeartbeat();
            }
        }

    }

    /**
     * API
     */
    GumboHeartbeat.prototype = {
        init: function() { },
        start: function() { },
        pause: function() { },
        stop: function() { },
        isActive: function() { }
    };


    return GumboHeartbeat;
});
